import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";

const Blog = () => {
    const [posts, setPosts] = useState([]);
    const [cat, setCat] = useState("All");

    useEffect(() => {
        api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
    }, []);

    const categories = ["All", ...Array.from(new Set(posts.map((p) => p.category)))];
    const filtered = cat === "All" ? posts : posts.filter((p) => p.category === cat);

    return (
        <main data-testid="blog-page" className="bg-[var(--st-cream)]">
            <section className="pt-36 lg:pt-44 pb-12">
                <div className="st-container">
                    <p className="eyebrow text-[var(--st-gold-deep)] mb-6">Journal · Studio notes</p>
                    <h1 className="font-serif leading-[0.92] tracking-tighter" style={{ fontSize: "clamp(3rem, 7vw, 7rem)" }}>
                        Things we think<br />
                        <span className="italic text-[var(--st-gold)]">out loud.</span>
                    </h1>
                </div>
            </section>

            <section className="border-t border-b border-[var(--st-line)] py-6">
                <div className="st-container flex gap-3 overflow-x-auto no-scrollbar">
                    {categories.map((c) => (
                        <button
                            key={c}
                            onClick={() => setCat(c)}
                            data-testid={`blog-filter-${c.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}
                            className={`shrink-0 px-4 py-2 text-xs uppercase tracking-widest border transition-colors ${
                                cat === c ? "bg-[var(--st-ink)] text-[var(--st-cream)] border-[var(--st-ink)]" : "border-[var(--st-line)] hover:border-[var(--st-ink)]"
                            }`}
                        >
                            {c}
                        </button>
                    ))}
                </div>
            </section>

            <section className="py-16 lg:py-24">
                <div className="st-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {filtered.map((p, i) => (
                        <motion.article
                            key={p.id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7, delay: i * 0.08 }}
                            data-testid={`blog-card-${p.slug}`}
                        >
                            <Link to={`/blog/${p.slug}`} className="block group">
                                <div className="aspect-[4/3] overflow-hidden mb-5 bg-[var(--st-cream-soft)]">
                                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                                </div>
                                <p className="eyebrow text-[var(--st-gold-deep)] mb-2">{p.category}</p>
                                <h3 className="font-serif text-3xl leading-tight group-hover:text-[var(--st-gold-deep)] transition-colors">{p.title}</h3>
                                <p className="mt-3 text-[var(--st-ink-soft)] leading-relaxed line-clamp-3">{p.excerpt}</p>
                                <p className="mt-4 text-xs uppercase tracking-widest opacity-70">{p.author}</p>
                            </Link>
                        </motion.article>
                    ))}
                </div>
                {filtered.length === 0 && (
                    <p className="text-center text-[var(--st-ink-soft)]">No posts in this category yet.</p>
                )}
            </section>
        </main>
    );
};

export default Blog;
